import React from 'react';
import PropTypes from 'prop-types';
// Custom
import ErrorsDisplayer from 'components/misc/ErrorsDisplayer';
import ScrollerElement from 'components/misc/ScrollerElement';

const RowDetailsTemplate = ({
  errors, errorDisplayerRef, buttons, children,
}) => (
  <React.Fragment>
    {(errors || buttons) && (
      <div className="box box-white box-transparent m-0 p-3">
        {errors && (
          <div className="row">
            <ScrollerElement target="errorDisplayer" name={errorDisplayerRef} className="w-100">
              <div className="col-12">
                <ErrorsDisplayer errors={errors} noFormRef />
              </div>
            </ScrollerElement>
          </div>
        )}
        {buttons && (
          <div className="d-flex align-items-start align-items-md-center flex-column flex-md-row left-spaced-buttons">
            {buttons}
          </div>
        )}
      </div>
    )}
    <div className="box box-transparent m-0" style={{ whiteSpace: 'normal' }}>
      {children}
    </div>
  </React.Fragment>
);

RowDetailsTemplate.propTypes = {
  errors: PropTypes.shape({
    global: PropTypes.string.isRequired,
  }),
  errorDisplayerRef: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.element),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
};

RowDetailsTemplate.defaultProps = {
  errors: null,
  errorDisplayerRef: null,
  buttons: null,
};

module.exports = RowDetailsTemplate;



// WEBPACK FOOTER //
// ./components/templates/RowDetailsTemplate.js